var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg24FlagCanada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "26px",
    height: "13px",
    viewBox: "0 0 26 13",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FF0000",
    width: 26,
    height: 13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    width: 13,
    height: 13,
    x: 6.5,
    y: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0000",
    d: " M13,1.219 l-0.887,1.654 c-0.101,0.18-0.281,0.163-0.461,0.063 l-0.642-0.333 l0.479,2.541 c0.101,0.464-0.223,0.464-0.382,0.264 L9.985,4.153 L9.803,4.79 C9.782,4.874,9.69,4.962,9.552,4.941 L8.135,4.643 l0.372,1.353 c0.08,0.301,0.142,0.426-0.081,0.505 L7.921,6.739 l2.439,1.982 c0.097,0.074,0.145,0.209,0.111,0.331 l-0.213,0.7 c0.84-0.096,1.592-0.242,2.433-0.332 c0.074-0.008,0.199,0.115,0.198,0.201 l-0.111,2.566h0.409 l-0.064-2.562 c0-0.086,0.112-0.214,0.187-0.206 c0.84,0.09,1.592,0.236,2.432,0.332 l-0.213-0.7 c-0.034-0.122,0.014-0.257,0.111-0.331 l2.439-1.982 l-0.506-0.238 c-0.222-0.079-0.16-0.204-0.08-0.505 l0.372-1.353 l-1.417,0.298 c-0.139,0.021-0.23-0.067-0.252-0.151 l-0.182-0.637 l-1.121,1.254 c-0.159,0.201-0.482,0.201-0.381-0.264 l0.479-2.541 l-0.643,0.333 c-0.18,0.101-0.36,0.117-0.461-0.063 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24FlagCanada);
export default __webpack_public_path__ + "static/media/24-flag-canada.8591947010f256d2ecff87be252db014.svg";
export { ForwardRef as ReactComponent };